export const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '480px',
    margin: '48px auto 64px auto',
    padding: theme.spacing(3),
    '@media (min-width: 960px)': {
      maxWidth: '560px',
      margin: '64px auto 80px auto'
    }
  },

  iconWrapper: {
    marginBottom: '16px'
  },

  icon: {
    fontSize: '72px',
    color: theme.palette.primary.main
  },

  heading: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: '#333',
    marginBottom: '8px',
    textAlign: 'center'
  },

  subheading: {
    fontSize: '1rem',
    color: '#777',
    marginBottom: '32px',
    textAlign: 'center'
  },

  card: {
    width: '100%',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    padding: '20px 24px',
    marginBottom: '16px'
  },

  recap: {
    width: '100%',
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '12px',
    padding: '14px 18px',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  recapRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    fontWeight: 500,
    color: '#14532d',
    lineHeight: 1.4
  },
  recapIcon: {
    color: '#16a34a',
    flexShrink: 0,
    marginTop: 1
  },

  cardTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#333',
    marginBottom: '6px'
  },

  cardText: {
    fontSize: '0.9rem',
    color: '#555',
    lineHeight: 1.6
  },

  link: {
    fontWeight: 500,
    cursor: 'pointer'
  },

  socialRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
    marginBottom: '32px'
  },

  socialText: {
    fontSize: '0.9rem',
    color: '#777'
  },

  homeButton: {
    borderRadius: '28px',
    padding: '12px 40px',
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    color: '#fff'
  }
})
